import {
  getTotalStopTime,
  getMinutesInHourAndMinutesStr,
} from "../../util";
import reportConstants from "../../constants";
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import constants from "./constants";
const getCurrentStopPopupStatusDetails = (task) => {
  const currentStopDuration = getTotalStopTime(
    task.start_date,
    task.currentDateTime
  );
  const estimatedStopDuration = task.stopDuration;
  const stopStatus =
    currentStopDuration > estimatedStopDuration
      ? `${
          reportConstants.DISPATCH_STOP_STATUS_TYPES.DELAYED
        } (${getMinutesInHourAndMinutesStr(
          currentStopDuration - estimatedStopDuration
        )})`
      : reportConstants.DISPATCH_STOP_STATUS_TYPES.ONTIME;
  const statusClass =
    stopStatus === reportConstants.DISPATCH_STOP_STATUS_TYPES.ONTIME
      ? "noViolation"
      : "violation";
  return { stopStatus, statusClass };
};

const CurrentStopPopup = ({ task }) => {
  const { stopStatus, statusClass } = getCurrentStopPopupStatusDetails(task);
  return (
    <PickupDeliveryPopupRenderer
      stopType={task?.data?.stopType}
      arrivalTime={task.arrivalTime}
      departureTime={task.estimatedDepartureTime}
      departureTimeLabel={constants.POPUP_LABELS.EST_DEPARTURE_TIME}
      stopTime={getMinutesInHourAndMinutesStr(task.stopDuration)}
      stopTimeLabel={constants.POPUP_LABELS.EST_STOP_TIME}
      statusLabel={constants.POPUP_LABELS.STATUS}
      statusValue={stopStatus}
      stopStatusClass={statusClass}
      serviceWindow={task?.data}
      stopData={task.data}
    />
  );
};

export default CurrentStopPopup;
